import {
    DATE_FORMAT,
    IReservation,
    ListItem,
    Pill,
    ReservationStatus,
    StringUtils,
    TIME_FORMAT,
    TPillTone,
} from '@localina/core';
import { DateIcon } from '@localina/icons';
import { DateTime } from 'luxon';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface IProps {
    reservation: IReservation;

    areaName?: string;
    onClick: (reservation: IReservation) => void;
}

const STATUS_TONES: Record<ReservationStatus, TPillTone> = {
    [ReservationStatus.APPROVAL_PENDING]: 'warn',
    [ReservationStatus.APPROVED]: 'teal',
    [ReservationStatus.FULFILLED]: 'good',
    [ReservationStatus.DECLINED]: 'neutral',
    [ReservationStatus.NO_SHOW]: 'critical',
    [ReservationStatus.GUEST_CANCELLED]: 'neutral',
    [ReservationStatus.RESTAURANT_CANCELLED]: 'neutral',
    [ReservationStatus.GUARANTEE_PENDING]: 'warn',
    [ReservationStatus.GUARANTEE_EXPIRED]: 'neutral',
};

export const GuestReservationListItem: React.FC<IProps> = (props) => {
    const { t } = useTranslation();

    const { reservationDateTime, participants, status } = props.reservation;
    const datetime = DateTime.fromISO(reservationDateTime, { zone: 'utc' }).toLocal();
    const date = datetime.isValid ? datetime.toFormat(DATE_FORMAT) : '';
    const time = datetime.isValid ? datetime.toFormat(TIME_FORMAT) : '';

    const handleClick = () => {
        props.onClick(props.reservation);
    };

    return (
        <ListItem
            classNames="guest-reservation-listitem"
            leftIcon={
                <span className="guest-reservation-listitem__date-icon">
                    <DateIcon />
                </span>
            }
            title={
                <div className="guest-reservation-listitem__row">
                    <div className="guest-reservation-listitem__main">
                        <span className="guest-reservation-listitem__when">
                            {StringUtils.combineStrings([date, time], ' · ')}
                        </span>
                        <span className="guest-reservation-listitem__what">
                            {StringUtils.combineStrings(
                                [t('guest.reservations.list.participants', { count: participants }), props.areaName],
                                ' · ',
                            )}
                        </span>
                    </div>
                    <Pill tone={STATUS_TONES[status]} label={t(`reservations.status.${status}`)} />
                </div>
            }
            onClick={handleClick}
        />
    );
};
